module.exports = __webpack_public_path__ + "img/bg.6e48588b.png";